import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function checkUsuarioPorEmail(email) {
  const base = getBase();
  if (!base || !email || !String(email).trim()) return { exists: false };
  try {
    const res = await axios.get(base + '/usuarios/por-email', {
      params: { email: String(email).trim().toLowerCase() },
      headers: getAuthHeaders(),
      timeout: 10000
    });
    const data = res?.data;
    if (data && data.exists && data.usuario) {
      return { exists: true, usuario: data.usuario };
    }
    return { exists: false };
  } catch (err) {
    if (err?.response?.status === 404) return { exists: false };
    console.error('Erro ao verificar e-mail:', err);
    throw err;
  }
}

export async function fetchAnalistas() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/usuarios/analistas', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    if (err?.response?.status === 404) return [];
    console.error('Erro ao listar analistas:', err);
    return [];
  }
}

export async function vincularUsuarioEmpresa(usuarioId, empresaId, grupoCodigo) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  const url = base + '/usuario-empresa';
  return axios.post(
    url,
    { usuario_id: Number(usuarioId), empresa_id: Number(empresaId), grupo_codigo: grupoCodigo || 'USU' },
    { headers: getAuthHeaders() }
  );
}
